var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidecart__line-item__quantity" },
    [
      _c("icon-button", {
        staticClass: "sidecart__line-item__quantity__change",
        attrs: {
          label: "Decrement Count",
          icon: "minus",
          height: "11px",
          width: "11px",
          disabled: _vm.disableDecrement,
        },
        on: { click: _vm.decrement },
      }),
      _c("p", { staticClass: "sidecart__line-item__quantity__label" }, [
        _vm._v(_vm._s(_vm.quantity)),
      ]),
      _c("icon-button", {
        staticClass: "sidecart__line-item__quantity__change",
        attrs: {
          label: "Increment Count",
          icon: "plus",
          height: "11px",
          width: "11px",
          disabled: _vm.disableIncrement,
        },
        on: { click: _vm.increment },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }